import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { IcsToast } from './types/ics-toast';
import { IcsToastType } from './types/ics-toast-type';
import { IcsToastService } from './ics-toast.service';
import { isNullOrUndefined } from 'util';
import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { Subscription } from 'rxjs';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'ics-toast',
  template: `<aside class="dialog" >
    <div class="ics-toast-container" *ngFor="let toast of toasts  ; let i=index;"
         [@flyInOut]="'in'">
        <div class="ics-toast">
            <img class="ics-toast__image"
                 src="{{toast.icon}}"/>

            <p class="ics-toast__text" [ngStyle]="textStyle(toast)">{{toast.message}}</p>
            <p (click)="removeToast(i)" class="ics-toast__close">X</p>

        </div>
    </div>

</aside>

`,
  styles: [`.dialog{position:fixed;right:20px;top:20px;z-index:9999999999999999999}.ics-toast-container{display:flex;box-shadow:0 0 6px 4px rgba(0,0,0,.4);min-width:300px;max-width:300px;min-height:50px;border-radius:5px;background:#3a134d;margin-bottom:20px;font-family:Raleway;font-size:15px}.ics-toast{display:flex}.ics-toast__image{height:20px;width:20px;margin-left:20px;margin-right:15px;order:1;flex-direction:row;align-self:center}.ics-toast p{order:1;flex-direction:row;align-self:center;margin-bottom:0!important}.ics-toast__close{cursor:pointer;font-size:12px;font-weight:700;color:rgba(255,255,255,.5);padding:4px 6px;order:1;flex-direction:row;-ms-grid-row-align:center;align-self:center;margin:0 5px}.ics-toast__close:hover{color:#fff}`],
  animations: [
    trigger('flyInOut', [
      state('in', style({opacity: 1, transform: 'translateX(0)'})),
      transition('void => *', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition('* => void', [
        animate('0.2s 0.1s ease-out', style({
          opacity: 0,
          transform: 'translateX(100%)'
        }))
      ])
    ])
  ]
})
export class IcsToastComponent implements OnInit, OnDestroy {
  readonly TIMEOUT = 5000;
  public toasts: IcsToast[];
  public subscription: Subscription;
  constructor(private toastService: IcsToastService, private router: Router) {
    this.toasts = [];
  }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.toasts = this.toasts.filter(x => {
          let flag = false;
          if (x.keepAfterRouteChange) {
            x.keepAfterRouteChange = false; // keep only for one router change
            flag = true;
          }
          return flag;
        });
      }
    });
    this.subscription = this.toastService.toast$.subscribe((next: IcsToast) => {
      if (isNullOrUndefined(next)) {
        this.toasts = []; // clear the toasts
      } else {
        this.toasts.unshift(next);
        setTimeout(() => {
          this.popToast();
        }, this.TIMEOUT);
      }
    });
  }

  public textStyle(toast: IcsToast): any {
    let color = '';
    if (toast.icon === IcsToastType.SUCCESS) {
      color = '#5CC1B6';
    } else if (toast.icon === IcsToastType.LOADING) {
      color = '#fff';
    } else if (toast.icon === IcsToastType.ERROR) {
      color = '#F26C4F';
    }
    return { color: color };
  }
  private popToast() {
    this.removeToast(this.toasts.length - 1);
  }
  public removeToast(index: number): void {
    this.toasts.splice(index, 1);
  }
  ngOnDestroy() {
    try {
      this.toasts = null;
      this.subscription.unsubscribe();
    } catch (e) {}
  }
}
